import type { Machine as MachineApi } from 'app/common/api/requests/data/vending/machines/get';
import type { MachineSingle } from 'app/dataTypes/vending/Machines.types';
import { getVendingMachineKind } from 'app/dataTypes/vending/MachineKind.types';


const api2machineState = (res: MachineApi): MachineSingle => {
  const {
    id,
    title,
    number,
    model_id: modelId,
    school_id: orgId,
    building_id: buildingId,
    sale_point_id: salePointId,
    version_id: versionId,
    kind,
    place_id: placeId,
  } = res;

  return {
    id,
    title,
    number,
    modelId,
    orgId,
    buildingId,
    salePointId,
    versionId,
    kind: getVendingMachineKind(kind),
    placeId: String(placeId),
  };
};

export default api2machineState;
